export const COPY_PREFERENCES_STORAGE_KEY = "moonscroll_copy_script_preferences";

export const COPY_TOGGLE_KEYS = {
  title: "title",
  description: "description",
  direction: "direction",
  masterCaption: "master_caption",
  sceneSpoken: "scene_spoken",
  sceneCaptions: "scene_captions",
  sceneVisualNotes: "scene_visual_notes",
  url: "url",
};

export const DEFAULT_COPY_PREFERENCES = {
  [COPY_TOGGLE_KEYS.title]: true,
  [COPY_TOGGLE_KEYS.description]: true,
  [COPY_TOGGLE_KEYS.direction]: true,
  [COPY_TOGGLE_KEYS.masterCaption]: true,
  [COPY_TOGGLE_KEYS.sceneSpoken]: true,
  [COPY_TOGGLE_KEYS.sceneCaptions]: true,
  [COPY_TOGGLE_KEYS.sceneVisualNotes]: true,
  [COPY_TOGGLE_KEYS.url]: true,
};

export const PRESET_EVERYTHING = "everything";
export const PRESET_SPOKEN_ONLY = "spoken_only";
export const PRESET_CREATOR_HANDOFF = "creator_handoff";

export function getPresetPreferences(preset) {
  switch (preset) {
    case PRESET_SPOKEN_ONLY:
      return {
        [COPY_TOGGLE_KEYS.title]: true,
        [COPY_TOGGLE_KEYS.description]: false,
        [COPY_TOGGLE_KEYS.direction]: false,
        [COPY_TOGGLE_KEYS.masterCaption]: false,
        [COPY_TOGGLE_KEYS.sceneSpoken]: true,
        [COPY_TOGGLE_KEYS.sceneCaptions]: false,
        [COPY_TOGGLE_KEYS.sceneVisualNotes]: false,
        [COPY_TOGGLE_KEYS.url]: false,
      };
    case PRESET_CREATOR_HANDOFF:
      return {
        [COPY_TOGGLE_KEYS.title]: true,
        [COPY_TOGGLE_KEYS.description]: true,
        [COPY_TOGGLE_KEYS.direction]: true,
        [COPY_TOGGLE_KEYS.masterCaption]: false,
        [COPY_TOGGLE_KEYS.sceneSpoken]: true,
        [COPY_TOGGLE_KEYS.sceneCaptions]: true,
        [COPY_TOGGLE_KEYS.sceneVisualNotes]: true,
        [COPY_TOGGLE_KEYS.url]: false,
      };
    case PRESET_EVERYTHING:
    default:
      return { ...DEFAULT_COPY_PREFERENCES };
  }
}
